import { render, staticRenderFns } from "./ChangeLayout.vue?vue&type=template&id=79953846&scoped=true"
import script from "./ChangeLayout.vue?vue&type=script&lang=ts"
export * from "./ChangeLayout.vue?vue&type=script&lang=ts"
import style0 from "./ChangeLayout.vue?vue&type=style&index=0&id=79953846&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79953846",
  null
  
)

export default component.exports